import styled from "styled-components";
import colors from "../../styles/colors";

export const Container = styled.button`
  background: ${colors.background.main};
  color: ${colors.primary};
  box-shadow: none;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${colors.background.hover};
  }

  &:disabled {
    background: ${colors.background.light};
    color: ${colors.loader.muted};
  }
`;
